import request from '@/utils/request'


// 查询仓库列表
export function listWarehouse(query) {
  return request({
    url: '/warehouse/warehouse/list',
    method: 'get',
    params: query
  })
}

// 查询仓库分页
export function pageWarehouse(query) {
  return request({
    url: '/warehouse/warehouse/page',
    method: 'get',
    params: query
  })
}

// 查询仓库详细
export function getWarehouse(data) {
  return request({
    url: '/warehouse/warehouse/detail',
    method: 'get',
    params: data
  })
}
export function getWarehouseList(data) {
  return request({
    url: '/warehouse/warehouse/getWarehouseList',
    method: 'get',
    params: data
  })
}

// 新增仓库
export function addWarehouse(data) {
  return request({
    url: '/warehouse/warehouse/add',
    method: 'post',
    data: data
  })
}

// 修改仓库
export function updateWarehouse(data) {
  return request({
    url: '/warehouse/warehouse/edit',
    method: 'post',
    data: data
  })
}

// 删除仓库
export function delWarehouse(data) {
  return request({
    url: '/warehouse/warehouse/delete',
    method: 'post',
    data: data
  })
}
